import { v4 as uuid4 } from 'uuid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import {
  VARIABLE_TEXT_FEATURE_FLAG_TEXT,
  VariableSelectFeatureFlag,
  VariableTextFeatureFlag,
} from '@makyoapp/makyo-common'

import { DEFAULT_RICH_TEXT_VALUE } from '@/shared/constants'

import { BuilderComponentGroup, BuilderComponentSettingType, ComponentSettingKey, MdShape } from '../types'
import { LABELS } from '../types/labels'
import {
  hoverEffectOptions,
  makeClampWidthItems,
  makeSpacing,
  makeTextColorSettings,
  makeTypography,
} from '../utils/components'

export const TextComponents: BuilderComponentGroup = {
  id: 'text',
  title: LABELS.TEXT_KEY,
  components: [
    {
      compId: 'text',
      title: LABELS.TEXT_KEY,
      searchKeywords: [
        'text',
        'label',
        'paragraph',
        'title',
        'heading',
        'body copy',
        'description',
        'caption',
        'plain text',
      ],
      icon: 'Text16',
      nested: false,
      //detailDataSource: undefined,
      settings: {
        data: [
          {
            id: ComponentSettingKey.TextDataValue,
            label: LABELS.TEXT_KEY,
            defaultValue: [{ type: 'paragraph', children: [{ text: 'Your text will appear here.' }] }],
            type: BuilderComponentSettingType.VariableText,
            variableTextSettings: {
              flags: VARIABLE_TEXT_FEATURE_FLAG_TEXT | VariableTextFeatureFlag.Icon | VariableTextFeatureFlag.SessionID,
            },
          },
          // {
          //   id: ComponentSettingKey.TextDataURL,
          //   label: 'URL',
          //   placeholder: 'Enter a valid URL',
          //   type: BuilderComponentSettingType.VariableText,
          //   validation: BuilderComponentSettingValidation.URL,
          //   autoDefaultInDetailPage: false,
          //   variableTextSettings: {
          //     flags: VARIABLE_TEXT_FEATURE_FLAG_NO_ICON & ~VariableTextFeatureFlag.ColumnData,
          //     columnTypes: [ColumnTypes.URL],
          //   },
          //   help: 'If defined text will become a link.',
          // },
        ],
        designGroup: {
          [LABELS.COLORS_KEY]: {
            items: [
              {
                id: ComponentSettingKey.TextDesignGroupColor,
                type: BuilderComponentSettingType.Group,
                label: '',
                groupItems: {
                  [LABELS.TEXT_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.TextDesignColor,
                      ComponentSettingKey.TextDesignColorSolid,
                      ComponentSettingKey.TextDesignColorStartGradient,
                      ComponentSettingKey.TextDesignColorEndGradient,
                      ComponentSettingKey.TextDesignColorGradientDirection,
                      ComponentSettingKey.TextDesignScheme,
                      LABELS.TEXT_KEY
                    ).items,
                  ],
                },
              },
            ],
          },
          // [LABELS.COLORS_KEY]: {
          //   items: [
          //     makeScheme(ComponentSettingKey.TextDesignScheme),
          //     {
          //       id: ComponentSettingKey.TextDesignColor,
          //       label: LABELS.TEXT_COLOR_KEY,
          //       type: BuilderComponentSettingType.ColorVariant,
          //       defaultValue: 'on-surface',
          //       colorVariantSettings: { schemeId: ComponentSettingKey.TextDesignScheme, fullColor: 'fg' },
          //     },
          //   ],
          // },
          // [LABELS.TEXT_COLOR_KEY]: {
          //   items: [
          //     {
          //       id: ComponentSettingKey.TextDesignColor,
          //       type: BuilderComponentSettingType.ColorVariant,
          //       defaultValue: 'on-primary',
          //       label: '',
          //       colorVariantSettings: {
          //         schemeId: '',
          //         fullColor: 'fg',
          //       },
          //     },
          //   ],
          // },
          [LABELS.DIMENSION_KEY]: makeClampWidthItems(ComponentSettingKey.TextDesignWidth, {
            defaultValue: 100,
            defaultUnit: '%',
            minValue: 10,
          }),
          [LABELS.TYPOGRAPHY_KEY]: makeTypography(ComponentSettingKey.TextDesignTypography, 'Body Large'),
          [LABELS.SPACING_KEY]: makeSpacing({
            padding: { id: ComponentSettingKey.TextDesignPadding, defaultValue: 10 },
            margin: { id: ComponentSettingKey.TextDesignMargin, defaultValue: { x: 10, y: 0 } },
          }),
          [LABELS.BORDER_KEY]: {
            items: [
              {
                id: ComponentSettingKey.TextDesignBorder,
                type: BuilderComponentSettingType.IconSelect,
                label: LABELS.SHOW_BORDER_KEY,
                iconSelectSettings: {
                  multiple: true,
                  options: [
                    { id: 'top', icon: 'BorderTop24', title: LABELS.BORDER_TOP_KEY },
                    { id: 'inline-end', icon: 'BorderRight24', title: LABELS.BORDER_END_KEY },
                    { id: 'bottom', icon: 'BorderBot24', title: LABELS.BORDER_BOTTOM_KEY },
                    { id: 'inline-start', icon: 'BorderLeft24', title: LABELS.BORDER_START_KEY },
                  ],
                },
              },
              {
                id: ComponentSettingKey.TextDesignBorderWidth,
                type: BuilderComponentSettingType.Slider,
                label: LABELS.BORDER_WIDTH_KEY,
                defaultValue: [0],
                sliderSettings: { max: 25, min: 0, step: 1, range: false },
                forceHorizontal: true,
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value) ? value.length > 0 : false
                  },
                },
              },
              // {
              //   id: ComponentSettingKey.TextDesignBorderColor,
              //   type: BuilderComponentSettingType.ColorVariant,
              //   label: LABELS.BORDER_COLOR_KEY,
              //   colorVariantSettings: {
              //     schemeId: '',
              //     fullColor: 'both',
              //   },
              //   forceHorizontal: true,
              //   dependOn: {
              //     id: ComponentSettingKey.TextDesignBorder,
              //     showWhen: (value?: unknown) => {
              //       return Array.isArray(value) ? value.length > 0 : false
              //     },
              //   },
              // },
              {
                id: ComponentSettingKey.TextDesignBorderStyle,
                type: BuilderComponentSettingType.Select,
                label: LABELS.BORDER_STYLE_KEY,
                selectSettings: {
                  options: [
                    { value: 'solid', label: 'Solid' },
                    { value: 'dotted', label: 'Dotted' },
                    { value: 'dashed', label: 'Dashed' },
                  ],
                },
                forceHorizontal: true,
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value) ? value.length > 0 : false
                  },
                },
              },
              {
                id: ComponentSettingKey.TextDesignCornerRadius,
                type: BuilderComponentSettingType.Select,
                label: LABELS.CORNER_RADIUS_KEY,
                defaultValue: MdShape.Medium,
                selectSettings: {
                  options: Object.entries(MdShape).map(([label, value]) => ({
                    value,
                    label: label.replace(/([a-z])([A-Z])/g, '$1 $2'),
                  })),
                },
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value) ? value.length > 0 : false
                  },
                },
              },
              /*{
                id: '',
                label: '',
                type: BuilderComponentSettingType.Divider,
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-top') && value.length > 1
                      : false
                  }
                }
              },
              // end
              {
                id: ComponentSettingKey.TextDesignBorderEndWidth,
                type: BuilderComponentSettingType.Slider,
                label: 'Border End Width',
                defaultValue: [0],
                forceHorizontal: true,
                sliderSettings: {
                  max: 25,
                  min: 0,
                  step: 1,
                  range: false
                },
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-end')
                      : false
                  }
                }
              },
              {
                id: ComponentSettingKey.TextDesignBorderEndColor,
                type: BuilderComponentSettingType.Color,
                label: 'Border End Color',
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-end')
                      : false
                  }
                }
              },
              {
                id: ComponentSettingKey.TextDesignBorderEndStyle,
                type: BuilderComponentSettingType.Select,
                label: 'Border End Style',
                forceHorizontal: true,
                selectSettings: {
                  options: [
                    {
                      value: 'solid',
                      label: 'Solid'
                    },
                    {
                      value: 'dotted',
                      label: 'Dotted'
                    },
                    {
                      value: 'dashed',
                      label: 'Dashed'
                    }
                  ]
                },
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-end')
                      : false
                  }
                }
              },
              {
                id: '',
                label: '',
                type: BuilderComponentSettingType.Divider,
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-end') &&
                          value.length > 1 &&
                          (value.includes('border-start') ||
                            value.includes('border-bottom'))
                      : false
                  }
                }
              },
              // start
              {
                id: ComponentSettingKey.TextDesignBorderStartWidth,
                type: BuilderComponentSettingType.Slider,
                label: 'Border Start Width',
                defaultValue: [0],
                forceHorizontal: true,
                sliderSettings: {
                  max: 25,
                  min: 0,
                  step: 1,
                  range: false
                },
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-start')
                      : false
                  }
                }
              },
              {
                id: ComponentSettingKey.TextDesignBorderStartColor,
                type: BuilderComponentSettingType.Color,
                label: 'Border Start Color',
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-start')
                      : false
                  }
                }
              },
              {
                id: ComponentSettingKey.TextDesignBorderStartStyle,
                type: BuilderComponentSettingType.Select,
                label: 'Border Start Style',
                forceHorizontal: true,
                selectSettings: {
                  options: [
                    {
                      value: 'solid',
                      label: 'Solid'
                    },
                    {
                      value: 'dotted',
                      label: 'Dotted'
                    },
                    {
                      value: 'dashed',
                      label: 'Dashed'
                    }
                  ]
                },
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-start')
                      : false
                  }
                }
              },
              {
                id: '',
                label: '',
                type: BuilderComponentSettingType.Divider,
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-start') &&
                          value.length > 1 &&
                          value.includes('border-bottom')
                      : false
                  }
                }
              },
              // bottom
              {
                id: ComponentSettingKey.TextDesignBorderBottomWidth,
                type: BuilderComponentSettingType.Slider,
                label: 'Border Bottom Width',
                defaultValue: [0],
                sliderSettings: {
                  max: 25,
                  min: 0,
                  step: 1,
                  range: false
                },
                forceHorizontal: true,
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-bottom')
                      : false
                  }
                }
              },
              {
                id: ComponentSettingKey.TextDesignBorderBottomColor,
                type: BuilderComponentSettingType.Color,
                label: 'Border Bottom Color',
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-bottom')
                      : false
                  }
                }
              },
              {
                id: ComponentSettingKey.TextDesignBorderBottomStyle,
                type: BuilderComponentSettingType.Select,
                label: 'Border Bottom Style',
                forceHorizontal: true,
                selectSettings: {
                  options: [
                    {
                      value: 'solid',
                      label: 'Solid'
                    },
                    {
                      value: 'dotted',
                      label: 'Dotted'
                    },
                    {
                      value: 'dashed',
                      label: 'Dashed'
                    }
                  ]
                },
                dependOn: {
                  id: ComponentSettingKey.TextDesignBorder,
                  showWhen: (value?: unknown) => {
                    return Array.isArray(value)
                      ? value.includes('border-bottom')
                      : false
                  }
                }
              }*/
            ],
          },
          [LABELS.ALIGNMENT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.TextDesignCompHAlign,
                type: BuilderComponentSettingType.ComponentAlignment,
                defaultValue: 'parent',
                label: LABELS.COMPONENT_ALIGNMENT_KEY,
              },
              {
                id: ComponentSettingKey.TextDesignHAlign,
                type: BuilderComponentSettingType.TextAlignment,
                label: LABELS.TEXT_ALIGNMENT_KEY,
                defaultValue: 'start',
              },
            ],
          },
          [LABELS.HOVER_EFFECT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.TextDesignHoverEffect,
                type: BuilderComponentSettingType.Select,
                label: LABELS.HOVER_EFFECT_KEY,
                selectSettings: {
                  options: hoverEffectOptions,
                },
              },
            ],
          },
        },
        action: [{ id: ComponentSettingKey.TextActionClick, label: LABELS.ON_CLICK_KEY, isSimple: false }],
        behavior: { visibility: true },
      },
    },
    {
      compId: 'rich-text',
      title: LABELS.RICH_TEXT_KEY,
      searchKeywords: [
        'rich text',
        'editor',
        'formatted text',
        'bold',
        'italic',
        'underline',
        'hyperlink',
        'markdown',
        'article',
        'content',
        'WYSIWYG',
        'HTML text',
      ],
      icon: 'NormalText16',
      nested: false,
      //detailDataSource: undefined,
      settings: {
        data: [
          {
            id: ComponentSettingKey.RichTextData,
            type: BuilderComponentSettingType.VariableSelect,
            label: LABELS.RICH_TEXT_KEY,
            defaultValue: {
              id: uuid4(),
              value: DEFAULT_RICH_TEXT_VALUE,
              flag: VariableSelectFeatureFlag.RichText,
            },
            variableSelectSettings: {
              flags:
                VariableSelectFeatureFlag.RichText |
                VariableSelectFeatureFlag.ColumnData |
                VariableSelectFeatureFlag.CurrentRow |
                VariableSelectFeatureFlag.SingleCell,
              columnTypes: [ColumnTypes.RichText],
            },
          },
        ],
        designGroup: {
          [LABELS.DIMENSION_KEY]: makeClampWidthItems(ComponentSettingKey.RichTextDesignWidth),
          [LABELS.ALIGNMENT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.RichTextDesignHAlign,
                type: BuilderComponentSettingType.ComponentAlignment,
                defaultValue: 'parent',
                label: LABELS.COMPONENT_ALIGNMENT_KEY,
              },
            ],
          },
          [LABELS.SPACING_KEY]: makeSpacing({
            margin: { id: ComponentSettingKey.RichTextDesignMargin, defaultValue: 5 },
          }),
          [LABELS.TEXT_COLORS_OPTION_KEY]: {
            items: [
              {
                id: ComponentSettingKey.RichTextDesignGroupTextColor,
                type: BuilderComponentSettingType.Group,
                label: '',
                groupItems: {
                  [LABELS.H1_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignH1Color,
                      ComponentSettingKey.RichTextDesignH1ColorSolid,
                      ComponentSettingKey.RichTextDesignH1ColorStartGradient,
                      ComponentSettingKey.RichTextDesignH1ColorEndGradient,
                      ComponentSettingKey.RichTextDesignH1ColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.H1_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.H2_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignH2Color,
                      ComponentSettingKey.RichTextDesignH2ColorSolid,
                      ComponentSettingKey.RichTextDesignH2ColorStartGradient,
                      ComponentSettingKey.RichTextDesignH2ColorEndGradient,
                      ComponentSettingKey.RichTextDesignH2ColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.H2_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.H3_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignH3Color,
                      ComponentSettingKey.RichTextDesignH3ColorSolid,
                      ComponentSettingKey.RichTextDesignH3ColorStartGradient,
                      ComponentSettingKey.RichTextDesignH3ColorEndGradient,
                      ComponentSettingKey.RichTextDesignH3ColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.H3_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.H4_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignH4Color,
                      ComponentSettingKey.RichTextDesignH4ColorSolid,
                      ComponentSettingKey.RichTextDesignH4ColorStartGradient,
                      ComponentSettingKey.RichTextDesignH4ColorEndGradient,
                      ComponentSettingKey.RichTextDesignH4ColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.H4_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.H5_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignH5Color,
                      ComponentSettingKey.RichTextDesignH5ColorSolid,
                      ComponentSettingKey.RichTextDesignH5ColorStartGradient,
                      ComponentSettingKey.RichTextDesignH5ColorEndGradient,
                      ComponentSettingKey.RichTextDesignH5ColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.H5_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.H6_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignH6Color,
                      ComponentSettingKey.RichTextDesignH6ColorSolid,
                      ComponentSettingKey.RichTextDesignH6ColorStartGradient,
                      ComponentSettingKey.RichTextDesignH6ColorEndGradient,
                      ComponentSettingKey.RichTextDesignH6ColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.H6_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.P_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignPColor,
                      ComponentSettingKey.RichTextDesignPColorSolid,
                      ComponentSettingKey.RichTextDesignPColorStartGradient,
                      ComponentSettingKey.RichTextDesignPColorEndGradient,
                      ComponentSettingKey.RichTextDesignPColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.P_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.OL_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignOlColor,
                      ComponentSettingKey.RichTextDesignOlColorSolid,
                      ComponentSettingKey.RichTextDesignOlColorStartGradient,
                      ComponentSettingKey.RichTextDesignOlColorEndGradient,
                      ComponentSettingKey.RichTextDesignOlColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.OL_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.UL_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.RichTextDesignUlColor,
                      ComponentSettingKey.RichTextDesignUlColorSolid,
                      ComponentSettingKey.RichTextDesignUlColorStartGradient,
                      ComponentSettingKey.RichTextDesignUlColorEndGradient,
                      ComponentSettingKey.RichTextDesignUlColorGradientDirection,
                      ComponentSettingKey.RichTextDesignScheme,
                      LABELS.UL_KEY,
                      'adaptive'
                    ).items,
                  ],
                },
              },
            ],
          },
        },
        behavior: { visibility: true },
      },
    },
  ],
}
